
import { Component, Watch } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import productOptionMixin from '@/mixin/productOption'
import currencyOptionMixin from '@/mixin/currencyOption'
import { getBalance, balanceExport } from '@/api/report'
import { dateToSeconds, getOneDate, pickerOptions } from '@/utils/dateTime'
import pagination from '@/components/Pagination/index.vue'
import { delObjEmptyKey, numberToString, stringToNumber } from '@/utils'
import { AppModule } from '@/store/modules/app'

@Component({
  name: 'balanceReport',
  components: {
    pagination
  }
})
export default class extends mixins(productOptionMixin, currencyOptionMixin) {
  queryForm: any = {
    merchant_no: null,
    start_time: null,
    end_time: null
  }
  private date: any[] = getOneDate()
  private pickerOptions = pickerOptions
  private sendLoading: boolean = false
  private list: any[] = []
  private listLoading: Boolean = false
  private totalData: any = {}
  private total = 0
  private listQuery = {
    page: 1,
    limit: 20
  }

  private currentOrdernumber: number | null = null
  private drawer: boolean = false

  private onDateChang () {
    this.pickerChange()
  }

  // 分页器设置
  private pagesize: number = 20
  private handleSizeChange (size) {
    this.pagesize = size
    this.hadleGetFilesListApi()
  }

  // 分页切换
  private currentPage: number = 1
  private handleCurrentChange (currentPage) {
    this.currentPage = currentPage
    this.hadleGetFilesListApi()
  }

  // 对所有数据进行分页处理 发送请求
  private async hadleGetFilesListApi () {
    try {
      this.listLoading = true
      const data: any = {
        ...this.queryForm,
        page_size: this.pagesize,
        page: this.currentPage
      }
      await getBalance(data).then((res: any) => {
        this.total = res.count
        this.list = res.results
        this.totalData = res.total_data
        this.listLoading = false
      })
    } catch (e) {
      this.listLoading = false
    }
  }

  // 创建时间监听
  @Watch('date', { immediate: true })
  private pickerChange () {
    if (this.date) {
      this.queryForm.start_time = dateToSeconds(this.date[0])
      this.queryForm.end_time = dateToSeconds(this.date[1])
    } else {
      this.queryForm.start_time = null
      this.queryForm.end_time = null
    }
  }

  // private getBalance (a: string, b: string, c: string) {
  //   return numberToStringNow(
  //     stringToNumber(a) + stringToNumber(b) + stringToNumber(c)
  //   )
  // }

  private currencyChange () {
    AppModule.SetCurrentCurrencyType(this.queryForm.currency)
    this.reset()
  }

  private select () {
    this.currentPage = 1
    this.hadleGetFilesListApi()
  }

  private reset () {
    this.queryForm = {
      currency: AppModule.currentCurrencyType,
      merchant_no: null,
      start_time: null,
      end_time: null
    }
    this.currentPage = 1
    this.date = getOneDate()
    this.pickerChange()
    // this.getList(true)
    this.hadleGetFilesListApi()
  }

  private async getList (isReset: boolean) {
    if (isReset) {
      this.listQuery.page = 1
    }
    try {
      this.listLoading = true
      const data: any = {
        ...this.queryForm,
        page: this.listQuery.page
      }
      delObjEmptyKey(data)
      await getBalance(data).then((res: any) => {
        this.total = res.count
        this.list = res.results
        this.totalData = res.total_data
        this.listLoading = false
      })
    } catch (e) {
      this.listLoading = false
    }
  }

  private async exportData () {
    try {
      this.sendLoading = true
      const data: any = {
        ...this.queryForm
      }
      delObjEmptyKey(data)
      await balanceExport(data).then(() => {
        this.$message({
          message: 'The form has been sent to your mailbox, please check it!',
          type: 'success'
        })
        this.sendLoading = false
      })
    } catch (e) {
      this.sendLoading = false
      this.$message({
        message: 'Export failure!',
        type: 'error'
      })
    }
  }

  private siteName = this.$store.state.app.enterprise.ssl_switch.site_name
  private systemName: any = 'Admin System'
  private sitelogo: any = this.$store.state.app.enterprise.ssl_switch.site_logo
  private systemLogo: any = ''

  private async init () {
    // this.getList(true)
    this.hadleGetFilesListApi()
  }

  mounted () {
    this.init()
    if (this.siteName && this.siteName !== '') {
      AppModule.SetSiteName(this.siteName)
      document.title = this.siteName + ' ' + this.$t(`route.operation`)
    } else {
      AppModule.SetSiteName(this.systemName)
      document.title = this.$t(`route.balance`) + '- Admin System'
    }
    if (this.sitelogo && this.sitelogo !== '') {
      AppModule.SetSiteLogo(this.sitelogo)
      let link: any =
        document.querySelector("link[rel*='icon']") ||
        document.createElement('link')
      link.type = 'image/x-icon'
      link.rel = 'shortcut icon'
      link.href = this.sitelogo
      document.getElementsByTagName('head')[0].appendChild(link)
    } else {
      AppModule.SetSiteLogo(this.systemLogo)
      let link: any =
        document.querySelector("link[rel*='icon']") ||
        document.createElement('link')
      link.type = 'image/x-icon'
      link.rel = 'shortcut icon'
      link.href = this.systemLogo
      document.getElementsByTagName('head')[0].appendChild(link)
    }
  }
}
